/* eslint-disable no-confusing-arrow */
import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';
import SendEmailToVendors from '../SendEmailToVendors';
import DeactivatePlanVendorList from '../DeactivatePlanVendorList';
import DeleteVendorList from '../DeleteVendorList';

const SubscriberCheckboxLists = ({
  subscriberType,
  checkboxes,
  setCheckboxes,
  rowSelection,
  setRowSelection,
}) => {
  const handleCheckboxChange = (id) => {
    setCheckboxes((prevCheckboxes) =>
      prevCheckboxes.map((checkbox) =>
        checkbox.id === id
          ? { ...checkbox, checked: !checkbox.checked }
          : checkbox,
      ),
    );
  };

  const resetRowSelection = () => {
    setRowSelection({});
  };
  return (
    <div className="d-flex align-items-center">
      {(subscriberType === 'subscribers' ||
        subscriberType === 'expireSubscribers') && (
        <form className="mt-3 bg-check-row d-flex me-4 mb-1">
          {checkboxes.map((checkbox) => (
            <FormGroup
              key={checkbox.id}
              className="bg-check me-1 d-inline-flex align-items-center mb-0"
              check
            >
              <Label
                htmlFor={checkbox.id}
                className="font-inter fw-medium"
                check
              >
                <Input
                  type="checkbox"
                  id={checkbox.id}
                  checked={checkbox.checked}
                  onChange={() => handleCheckboxChange(checkbox.id)}
                />
                <span className="ms-1">{checkbox.label}</span>
              </Label>
            </FormGroup>
          ))}
        </form>
      )}
      {Object.keys(rowSelection).length ? (
        <div className="muiltiple-action-box d-flex align-items-center ps-3 mt-3 mb-1">
          <span className="text-dark me-3">
            Viewing{' '}
            <span className="fw-semibold">
              {Object.keys(rowSelection).length} selected
            </span>{' '}
            from list of vendors
          </span>
          <SendEmailToVendors
            rowSelection={Object.keys(rowSelection)}
            resetRowSelection={resetRowSelection}
          />
          <DeactivatePlanVendorList
            rowSelection={Object.keys(rowSelection)}
            resetRowSelection={resetRowSelection}
          />
          <DeleteVendorList
            rowSelection={Object.keys(rowSelection)}
            resetRowSelection={resetRowSelection}
          />
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default SubscriberCheckboxLists;
